import React from 'react'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'
import { CaseStudyStat } from '../../api/Types'

export function parseStat(stat): number {
  return typeof stat === 'string'
    ? Number(stat)
    : typeof stat?.amount === 'string'
    ? Number(stat.amount)
    : 0
}

const useInViewOptions = {
  threshold: 0.3,
  triggerOnce: true,
}

interface Props {
  HeadingTag?: 'h2' | 'h3'
  defaultHeading?: string
  defaultLabel?: string
  stat?: CaseStudyStat | string
  duration?: number
  textHelper?: string | React.ReactNode
}

const CaseStudyStat: React.FC<Props> = ({
  HeadingTag,
  defaultHeading,
  defaultLabel = 'hours',
  stat,
  duration = 6,
  textHelper,
}) => {
  const time = parseStat(stat)

  const [viewRef, inView] = useInView(useInViewOptions)

  if (!stat) return null

  const heading = typeof stat === 'string' ? defaultHeading : stat?.name || defaultHeading

  return (
    <>
      {HeadingTag && defaultHeading && (
        <HeadingTag className='case-study-stats-title'>{heading}:</HeadingTag>
      )}
      <div className='case-study-stat' ref={viewRef}>
        <div className='case-study-stat-count'>
          <CountUp
            duration={duration}
            decimals={Number.isInteger(time) ? 0 : 1}
            end={inView ? time : 0}
          >
            {({ countUpRef }) => <span ref={countUpRef} />}
          </CountUp>{' '}
          {typeof stat !== 'string' && stat?.label ? stat.label : defaultLabel}
        </div>
        {textHelper && <div className='case-study-stat-text-helper'>{textHelper}</div>}
      </div>
    </>
  )
}

export default CaseStudyStat
